import isEmpty from 'lodash/isEmpty';
import { AUTH_TOKEN_STORAGE_KEY } from 'src/pages/Login/constants';
/* eslint-disable func-names */

/**
 * Reference: https://gist.github.com/allenhwkim/19c2f36a7afa6f0c507008613e966d1b
 */

/**
 * see: https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/API/cookies/set
 * for possible options
 */

interface SetCookieObj {
  domain: string;
  secure: string;
  sameSite: 'strict' | 'lax' | 'none';
  expires: string | null;
  path: string;
}

interface SetCookieParam {
  name: string;
  value: string;
  days?: number;
  domain?: string;
  hours?: number;
  sameSite?: SetCookieObj['sameSite'];
  partitioned?: boolean;
  expires?: Date;
}

interface GetAllResult {
  [x: string]: string;
}

export const CookieHelper = {
  set: function ({ name, value, days, domain, hours, sameSite, partitioned, expires }: SetCookieParam) {
    const sanitizedValue = typeof value !== 'string' ? '' : value;

    const cookie: SetCookieObj = {
      [name]: sanitizedValue,
      //set cookie domain as top level domain
      domain: domain || window.location.hostname,
      // serve over https only
      secure: 'true',
      // only visible to domain assigned
      sameSite: sameSite || 'strict',
      // set expiry date
      expires: '',
      // set cookie path default to current url path if not specified and causes cookies to be set separately for each path when not specified
      path: '/',
    };

    // calculate and set expiry date
    if (days && typeof days === 'number' && days > 0) {
      const date: Date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookie.expires = date.toUTCString();
    }

    if (hours && typeof hours === 'number' && hours > 0) {
      const date: Date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      cookie.expires = date.toUTCString();
    }

    if (expires) {
      cookie.expires = expires.toUTCString();
    }

    const arr: string[] = [];
    Object.keys(cookie).forEach((key) => {
      arr.push(`${key}=${cookie[key as keyof SetCookieObj] || ''}`);
    });

    if (partitioned) {
      arr.push('Partitioned');
    }

    try {
      document.cookie = arr.join('; ');
    } catch (e) {
      console.error(e);
    }
  },

  getAll: function (): GetAllResult {
    const cookie: GetAllResult = {};

    // multiple cookies are separated by ;
    document.cookie.split(';').forEach((el) => {
      /**
       * - trim white spaces
       * - cookie key value pair is separated by = but base64 encoded value can have = in it, so we need to split by the first =
       */
      const [k, v] = el.trim().split(/=(.*)/);

      cookie[k?.trim?.() || ''] = v;
    });

    return cookie;
  },

  get: function (name: string): string | null {
    const value: string | undefined = this.getAll()[name];

    return isEmpty(value) ? null : value;
  },

  delete: function (name: string) {
    if (name === AUTH_TOKEN_STORAGE_KEY) {
      this.set({
        name,
        value: '',
        expires: new Date(0),
        domain: '.consensusadvertising.com',
      });

      this.set({
        name,
        value: '',
        expires: new Date(0),
        domain: window.location.hostname,
      });

      return;
    }

    this.set({
      name,
      value: '',
      expires: new Date(0),
    });
  },
} as const;
